module.exports = __webpack_public_path__ + "img/midia-hojeemdia-1024x1024.59d57c35.png";